import * as Yup from 'yup';
import {PhoneNumberRegex, GhanaPostRegex} from "../../../utils/regex";

export const CreateTestingFacilityFormSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  address: Yup.string().required("Address is required"),
  ghanaPostAddress: Yup.string().required("GhanaPost Address is required").matches(GhanaPostRegex),
  contactPerson: Yup.object({
    fullName: Yup.string().required("Full Name is required"),
    emailAddress: Yup.string().email("Email Address is required"),
    phoneNumber: Yup.string().required("Phone number is required").matches(PhoneNumberRegex),
  })
})

export const CreateTestingFacilityInitialValues = {
  name: "",
  address: "",
  ghanaPostAddress: "",
  contactPerson: {
    fullName: "",
    emailAddress: "",
    phoneNumber: "",
  }
}